export default "__VITE_ASSET__o5CTf_yk__"